"use strict";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _const = require("../../const");

var _style = require("./style");

var _ChartIcon = _interopRequireDefault(require("../ChartIcon"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var ChartList = function ChartList(_ref) {
  var list = _ref.list,
      setData = _ref.setData,
      title = _ref.title;
  return _react["default"].createElement(_react.Fragment, null, list.length > 0 && _react["default"].createElement("div", null, _react["default"].createElement(_style.StyledTitle, null, title), _react["default"].createElement(_style.StyledIcons, null, list.map(function (el, key) {
    return _react["default"].createElement(_ChartIcon["default"], _extends({
      key: key,
      setData: setData
    }, el));
  }))));
};

var ChartMenu = function ChartMenu(_ref2) {
  var options = _ref2.options,
      getValue = _ref2.getValue,
      setValue = _ref2.setValue,
      innerRef = _ref2.innerRef,
      innerProps = _ref2.innerProps;
  var data = getValue()[0];

  var menu = _const.MENU_DATA.map(function (menu) {
    return _objectSpread({}, menu, {
      active: menu.type === data.chartType,
      disabled: !options.find(function (o) {
        return o.chartType === menu.type;
      })
    });
  });

  var columns = menu.filter(function (m) {
    return m.type === _const.TYPE_BAR || m.type === _const.TYPE_STACKED_BAR;
  });
  var bars = menu.filter(function (m) {
    return m.type === _const.TYPE_BAR_HORIZONTAL || m.type === _const.TYPE_STACKED_BAR_HORIZONTAL;
  });
  var more = menu.filter(function (m) {
    return m.type !== _const.TYPE_BAR && m.type !== _const.TYPE_STACKED_BAR && m.type !== _const.TYPE_BAR_HORIZONTAL && m.type !== _const.TYPE_STACKED_BAR_HORIZONTAL;
  });

  var setData = function setData(selected) {
    var dataSet = options.find(function (el) {
      return el.chartType === selected.type;
    });
    if (dataSet) setValue(dataSet);
  };

  return _react["default"].createElement(_style.StyledContainer, _extends({
    ref: innerRef
  }, innerProps), _react["default"].createElement(_style.StyledMenu, null, _react["default"].createElement(ChartList, {
    title: "Columns",
    setData: setData,
    list: columns
  }), _react["default"].createElement(ChartList, {
    title: "Bars",
    setData: setData,
    list: bars
  }), _react["default"].createElement(ChartList, {
    title: "More",
    setData: setData,
    list: more
  })));
};

var _default = ChartMenu;
exports["default"] = _default;